export const environment = {
  production: false,
  formActions: ['saveAndBack', 'save', 'advancedSearch', 'back'],
  baseUrl: `https://test.aysko.net/api`,
  VERSION: require('../../package.json').version,
  dateTimeFormat: 'YYYY-MM-DD HH:mm:SS',
  dateFormat: 'YYYY-MM-DD',
  visibleButtonsCount: 3,
  /** Empty by default — set in deploy config when Sentry is provisioned (AC-18). */
  sentryDsn: '',
  /** Optional collector URL for scrubbed error events (beacon / POST). */
  errorReportingUrl: '',
};
